'use client';

import { PropsWithChildren, ReactElement } from 'react';
import { useAppointment } from '@provider-directory/contexts/AppointmentContext';
import { DecisionTreeProvider } from '@provider-directory/contexts/DecisionTreeContext';
import { ProviderResource } from '@provider-directory/types/providers.contracts';

export const DecisionTreeProviderWrapper = ({
  children,
}: PropsWithChildren): ReactElement => {
  const { appointment } = useAppointment();

  return (
    <DecisionTreeProvider provider={appointment.provider as ProviderResource}>
      {children}
    </DecisionTreeProvider>
  );
};
